export default "__VITE_ASSET__Cmva6jK2__"